import { __awaiter, __decorate, __metadata } from "tslib";
import { inject, injectable, postConstruct } from 'mana-syringe';
import { ICommandHandler, ICommandContextProvider } from '../../command/interface';
import { XFlowGraphCommands } from '../constant';
import { Disposable } from '../../common/disposable';
export var NsRedoCmd;
(function (NsRedoCmd) {
    /** Command Id: 用于注册named factory */
    NsRedoCmd.command = XFlowGraphCommands.REDO_CMD;
    /** hookName */
    NsRedoCmd.hookKey = 'redoCommand';
})(NsRedoCmd || (NsRedoCmd = {}));
let GraphRedoCommand = class GraphRedoCommand {
    constructor() {
        /** 执行Cmd */
        this.execute = () => __awaiter(this, void 0, void 0, function* () {
            const ctx = this.ctx;
            const { args, hooks: runtimeHook } = ctx.getArgs();
            const hooks = ctx.getHooks();
            yield hooks.redoCommand.call(
            /** 执行hooks pipeline处理args */
            args, 
            /** 执行 callback */
            () => __awaiter(this, void 0, void 0, function* () {
                const cmds = ctx.getCommands();
                if (cmds.isRedoable) {
                    cmds.redoCommand();
                }
                /** 设置结果 */
                this.ctx.addUndo(Disposable.create(() => {
                    cmds.redoCommand();
                }));
                return {};
            }), 
            /** 外部的 hook */
            runtimeHook);
            return this;
        });
        /** undo cmd */
        this.undo = () => __awaiter(this, void 0, void 0, function* () {
            this.ctx.undo();
            return this;
        });
        /** redo cmd */
        this.redo = () => __awaiter(this, void 0, void 0, function* () {
            if (!this.ctx.isUndoable) {
                yield this.execute();
            }
            return this;
        });
    }
    init() {
        this.ctx = this.contextProvider();
    }
    /** isUndoable */
    isUndoable() {
        return this.ctx.isUndoable();
    }
};
__decorate([
    inject(ICommandContextProvider),
    __metadata("design:type", Object)
], GraphRedoCommand.prototype, "contextProvider", void 0);
__decorate([
    postConstruct(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], GraphRedoCommand.prototype, "init", null);
GraphRedoCommand = __decorate([
    injectable({
        token: { token: ICommandHandler, named: NsRedoCmd.command.id },
    })
    /** 创建节点命令 */
], GraphRedoCommand);
export { GraphRedoCommand };
//# sourceMappingURL=graph-cmd-redo.js.map